/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Err_VerifyInputs */

const tr_mascot_chat_err_verify = /** @type {(inputs: Mascot_Chat_Err_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen doğrulamayı tamamla.`)
};

const en_mascot_chat_err_verify = /** @type {(inputs: Mascot_Chat_Err_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please complete the verification.`)
};

const de_mascot_chat_err_verify = /** @type {(inputs: Mascot_Chat_Err_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte schließe die Verifizierung ab.`)
};

const ru_mascot_chat_err_verify = /** @type {(inputs: Mascot_Chat_Err_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, пройдите проверку.`)
};

/**
* | output |
* | --- |
* | "Please complete the verification." |
*
* @param {Mascot_Chat_Err_VerifyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_err_verify = /** @type {((inputs?: Mascot_Chat_Err_VerifyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Err_VerifyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_err_verify(inputs)
	if (locale === "de") return de_mascot_chat_err_verify(inputs)
	if (locale === "ru") return ru_mascot_chat_err_verify(inputs)
	return tr_mascot_chat_err_verify(inputs)
});